import { Head, useForm, Link } from '@inertiajs/react'
import AdminLayout from '../../components/layout/AdminLayout'
import Input from '../../components/ui/Input'
import Select from '../../components/ui/Select'
import Button from '../../components/ui/Button'

export default function QrCodesNew() {
  const { data, setData, post, processing, errors } = useForm({
    campaign_name: '',
    property_address: '',
    property_type: '',
    metadata: {
      color: '#000000'
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    post('/qr_codes')
  }

  return (
    <AdminLayout>
      <Head title="Nouveau QR Code" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Créer un QR Code</h1>
          <p className="mt-2 text-sm text-gray-600">
            Générez un QR Code personnalisé pour votre campagne ou bien immobilier
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white shadow-sm rounded-lg p-6 space-y-6">
          <Input
            label="Nom de la campagne"
            name="campaign_name"
            value={data.campaign_name}
            onChange={(e) => setData('campaign_name', e.target.value)}
            placeholder="Ex: Portes ouvertes Mars 2024"
            error={errors.campaign_name}
            required
          />

          <Input
            label="Adresse du bien (optionnel)"
            name="property_address"
            value={data.property_address}
            onChange={(e) => setData('property_address', e.target.value)}
            placeholder="Ex: 123 Rue de la Paix, Paris"
            error={errors.property_address}
          />

          <Select
            label="Type de bien (optionnel)"
            name="property_type"
            value={data.property_type}
            onChange={(e) => setData('property_type', e.target.value)}
            error={errors.property_type}
            placeholder="Sélectionnez un type"
            options={[
              { value: 'appartement', label: 'Appartement' },
              { value: 'maison', label: 'Maison' },
              { value: 'terrain', label: 'Terrain' },
              { value: 'commercial', label: 'Commercial' },
              { value: 'bureaux', label: 'Bureaux' }
            ]}
          />

          {/* Couleur du QR code */}
          <div>
            <label htmlFor="color" className="block text-sm font-medium text-gray-700 mb-2">
              Couleur du QR Code
            </label>
            <div className="flex items-center gap-4">
              <input
                type="color"
                id="color"
                value={data.metadata.color}
                onChange={(e) => setData('metadata', { ...data.metadata, color: e.target.value })}
                className="h-10 w-20 rounded border-gray-300"
              />
              <span className="text-sm text-gray-600">{data.metadata.color}</span>
            </div>
            <p className="mt-1 text-xs text-gray-500">
              Choisissez une couleur qui correspond à votre charte graphique
            </p>
          </div>

          {/* Boutons */}
          <div className="flex items-center justify-end gap-4 pt-4 border-t">
            <Button
              variant="secondary"
              href="/qr_codes"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              disabled={processing}
              variant="primary"
            >
              {processing ? 'Création...' : 'Créer le QR Code'}
            </Button>
          </div>
        </form>
      </div>
    </AdminLayout>
  )
}
